// extracted by mini-css-extract-plugin
export default {"wrapper":"QD-z","viewport":"RD-z","container":"SD-z","slide":"TD-z"};